import { render } from "./SaveModalInputs.vue?vue&type=template&id=5b9f9128&scoped=true"
import script from "./SaveModalInputs.vue?vue&type=script&lang=js"
export * from "./SaveModalInputs.vue?vue&type=script&lang=js"

import "./SaveModalInputs.vue?vue&type=style&index=0&id=5b9f9128&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9f9128"]])

export default __exports__